import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'set_modal_showing',
  stateProp: 'modalShowing',
  defaultState: {
    modalShowing: false
  },
  handler(modalShowing) {
    return { modalShowing };
  },
  reduce(state, { modalShowing }) {
    return { modalShowing };
  }
});
